import React, { ReactNode } from 'react';
import { Route } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import DSPCharts from '../Charts/DSP';
import OfficialCharts from '../Charts/Official';

import { EntityContext } from 'context/entityContext';

import { chartsSubTopics } from 'topics';
import { IEntityPageComponentProps } from 'pages/Entity/shared';
import TopicFilters from 'components/TopicFilters/TopicFilters';
import PositionTracker from '../Shared/PositionTracker';

const VersionCharts: React.FC<IEntityPageComponentProps> = (props) => {
  const { match, pathPrefix } = props;
  const { entityId, parentEntityId } = match.params;
  const ctx = React.useContext(EntityContext);

  const { compareMode, topic } = ctx;

  return (
    <>
      <SubNavigation topic="charts" variants={chartsSubTopics} />
      <TopicFilters topic={topic[1] || topic[0]} compareMode={compareMode} />

      <Route
        exact
        path={`${pathPrefix}/track/${parentEntityId}/version/${entityId}/charts/dsp`}
        render={(routerProps): ReactNode => (
          <DSPCharts {...ctx} {...routerProps} />
        )}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${parentEntityId}/version/${entityId}/charts/official`}
        render={(routerProps): ReactNode => (
          <OfficialCharts {...ctx} {...routerProps} />
        )}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${parentEntityId}/version/${entityId}/charts/positionTracker`}
        render={(routerProps): ReactNode => (
          <PositionTracker {...ctx} {...routerProps} />
        )}
      />
    </>
  );
};

export default VersionCharts;
